/**
 * Set experiment flags into local storage so that they are stable per
 * session (page load) when read from local storage into the module.
 * This means the experiment value is one reload behind what Eppo may
 * report in memory.
 *
 * EXAMPLE IMPLEMENTATION OF A SESSION EXPERIMENT:
 *
 * import { SafeLocalStorage } from 'pplx/frontend/browser-storage/localStorage';
 *
 * const EPPO_FLAG_NAME_LOCAL_STORAGE_KEY = 'pplx.eppo_flag_name.eppo_cache';
 *
 * // This value should not change over the lifetime of the web app, even if the saved value changes.
 * let cachedValue: boolean | undefined;
 * function getShouldShowEppoFlagName(): boolean {
 *   if (typeof cachedValue == 'undefined') {
 *     try {
 *       cachedValue =
 *         SafeLocalStorage.getItem(EPPO_FLAG_NAME_LOCAL_STORAGE_KEY) == 'true';
 *     } catch {
 *       cachedValue = false;
 *     }
 *   }
 *   return cachedValue;
 * }
 *
 * // Saving this will take effect the next time the user opens the page.
 * export function saveShouldShowEppoFlagName(shouldShow: boolean): void {
 *   SafeLocalStorage.setItem(
 *     EPPO_FLAG_NAME_LOCAL_STORAGE_KEY,
 *     shouldShow.toString(),
 *   );
 * }
 *
 * export function useShouldShowEppoFlagName(): boolean {
 *   return getShouldShowEppoFlagName();
 * }
 *
 */
export function SessionExperiments() {
    return null;
}
//# sourceMappingURL=SessionExperiments.js.map